import moment from "moment-timezone";
import {
  getLocalPhoneNumber,
  getPdfMargins,
  getAnalyticsValue,
  replaceBraces,
  getWeekday,
  getTranslatedValue,
  calculateTableSummaryRow,
} from "../../util/helpers";

const formatItemValue = (item, column, intl) => {
  if (column && column.meta) {
    if (column.meta.phone) return getLocalPhoneNumber(item);
    if (column.meta.email) return item === null || item === "" ? " " : item;
    if (column.meta.weekday) return getWeekday(item);
    if (column.meta.translated) return getTranslatedValue(item, intl);
    if (column.meta.time)
      return moment(item).isValid()
        ? moment.utc(item).tz("Asia/Jerusalem").format("DD/MM/YYYY")
        : "";
  }

  if (column && column.type === "time") {
    return moment(item).isValid()
      ? moment.utc(item).tz("Asia/Jerusalem").format("DD/MM/YYYY")
      : "";
  }

  if (column && column.type === "number") {
    return item
      ? `${(Math.round(item * 100) / 100).toString()}${
          column.format === "percent" ? "%" : ""
        }`
      : "";
  }

  return getAnalyticsValue(intl, item);
};

export const getItems = (data, columns, intl, report) => {
  const { support_totals } = report;
  const query = data?.loadResponse?.results[0].query;
  const dimensionsKeys = query.dimensions;
  const measuresKeys = query.measures;
  const timeDimensionsKeys = query.timeDimensions.map(
    (i) => i.granularity && i.dimension
  );
  const result = dimensionsKeys.concat(measuresKeys, timeDimensionsKeys);

  const sortedArray = data["backwardCompatibleData"][0].map((data) => {
    const sortedObject = {};
    result.forEach((key) => {
      if (data[key] !== undefined) {
        sortedObject[key] = data[key];
      }
    });

    for (const key in data) {
      if (sortedObject[key] === undefined) {
        sortedObject[key] = data[key];
      }
    }

    return sortedObject;
  });

  // Format the items
  const formattedItems = sortedArray.map((item) => {
    const formattedItem = {};
    Object.keys(item)
      .reverse()
      .forEach((key) => {
        const column = columns.find((col) => col.dataIndex === key);
        if (column) {
          formattedItem[key] = formatItemValue(item[key], column, intl);
        }
      });
    return formattedItem;
  });

  // Add summary row if support_totals is true
  if (support_totals) {
    const summaryRow = calculateTableSummaryRow(columns, sortedArray);
    return [...formattedItems, summaryRow];
  }

  return formattedItems;
};

export const setHeader = (doc, record) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  var title = record.name;
  const report = "תאריך הדפסה";
  const date = `${moment().format("HH:mm DD/MM/YYYY")}`;
  const reportDate = `${report} - ${date}`;
  const margins = getPdfMargins(doc);
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  doc.text(title, hLoc, 20, {
    align: "right",
  });
  doc.setFontSize(10);
  doc.text(reportDate, margins, 20, {
    align: "left",
  });
};
